// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Loading} from '../containers/Loading';
import { bindActionCreators } from 'redux';
import { getAllEquipment } from '../state/actions/EquipmentActions';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, FormGroup } from 'reactstrap';

//COMPONENT

class SegmentEquipmentModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            allEquipment: [],
            filteredEquipment: [],
            assignedEquipment: [],
            selectedEquipmentID: '',
            selectedEquipmentIDs: [],
            isValid: true
        };

        this.filterAllEquipment = this.filterAllEquipment.bind(this);
        this.addEquipment = this.addEquipment.bind(this);
        this.dismissModal = this.dismissModal.bind(this);
        this.selectChanged = this.selectChanged.bind(this);
        this.getIDFromName = this.getIDFromName.bind(this);
    }

    componentDidMount(){
        this.props.getAllEquipment();
        this.setState({assignedEquipment: this.props.assignedEquipment});
    }

    componentDidUpdate(prevProps) {
        if (this.props.allEquipment != prevProps.allEquipment) {
            this.setState({ allEquipment: this.props.allEquipment });
            this.filterAllEquipment(this.props.allEquipment, this.props.assignedEquipment);
        }

        if(this.props.assignedEquipment != prevProps.assignedEquipment){
            this.setState({assignedEquipment: this.props.assignedEquipment});
            this.filterAllEquipment(this.props.allEquipment, this.props.assignedEquipment);
        } 
    }

    dismissModal(){
        this.props.toggleModal();
    }

    filterAllEquipment(allEquipment, assignedEquipment){
        let filteredEquipment = [];
        if(assignedEquipment.length != 0){
            filteredEquipment = this.state.allEquipment.filter(item => !assignedEquipment.some(assigneditem => assigneditem.id == item.id));
        } else {
            filteredEquipment = allEquipment;
        }
        this.setState({
            filteredEquipment: filteredEquipment
        });
    }

    selectChanged(e){
        var options = e.target.options;
        var value = [];
        for (var i = 0, l = options.length; i < l; i++) {
            if (options[i].selected) {
                let id = this.getIDFromName(options[i].value);
                if(id != undefined && id != null){
                    value.push(id);
                }
            }
        }

        this.setState({selectedEquipmentIDs: value});
    }

    getIDFromName(name) {
        for(let item of this.state.allEquipment) {
            if(item.name == name) {
                return item.id;
            }
        }
        return null;
    }

    addEquipment(){
        if(this.state.selectedEquipmentIDs != undefined && this.state.selectedEquipmentIDs.length > 0){
            this.setState({isValid: true});
            this.props.addEquipment(this.state.selectedEquipmentIDs);
            this.props.toggleModal();
        } else {
            this.setState({isValid: false});
        }
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle} >
                    <ModalHeader toggle={this.toggle}>Add Equipment</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            {this.props.fetchingAllEquipment && <Loading/>}
                            {this.props.fetchedAllEquipment && 
                                <Input type="select" name="select" multiple id="typeSelect" onChange={this.selectChanged}>
                                    {this.state.filteredEquipment.map((item) => {return (<option key={item.id}>{item.name}</option>);})}
                                </Input>
                            }
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="button" color="secondary" onClick={this.dismissModal}>Cancel</Button>
                        <Button className="button" color="primary" onClick={this.addEquipment}>Add</Button>{' '}
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }
}

SegmentEquipmentModal.propTypes = {
    allEquipment: PropTypes.array.isRequired,
    getAllEquipment: PropTypes.func.isRequired,
    fetchingAllEquipment: PropTypes.bool.isRequired,
    fetchedAllEquipment: PropTypes.bool.isRequired,
    failedAllEquipment: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggleModal: PropTypes.func.isRequired,
    assignedEquipment: PropTypes.array.isRequired,
    addEquipment: PropTypes.func.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { allEquipment, fetchingAllEquipment, fetchedAllEquipment, failedAllEquipment} = state.equipmentReducer;
    return { allEquipment, fetchingAllEquipment, fetchedAllEquipment, failedAllEquipment };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ getAllEquipment }, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(SegmentEquipmentModal));

// EXPORT COMPONENT
export { hoc as SegmentEquipmentModal };


// WEBPACK FOOTER //
// ./src/components/modals/SegmentEquipmentModal.js